/**
 * "See an example of a finished case" on the free bill page (2026-10-27).
 * One screen, no scrolling: the bill as it came in and the same bill after
 * the case, line by line. Made-up hospital and numbers, and it says so.
 */
import Modal from './Modal';
import '@styles/components/example-case.css';

const LINES = [
  { what: 'Emergency room visit, level 5', was: '2,310.00', now: '1,170.00', why: 'Billed at the highest level for a short visit' },
  { what: 'Complete blood count', was: '186.00', now: '0.00', why: 'Billed twice on the same day' },
  { what: 'CT scan, head', was: '2,324.00', now: '2,324.00', why: null },
];

export default function ExampleCaseModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Modal open={open} onClose={onClose} className="exc" showClose closeLabel="Close example">
      <h2 className="exc-title">An example case</h2>
      <p className="exc-sub">An ER bill, before and after. Made-up hospital and numbers.</p>

      <div className="exc-bill">
        <div className="exc-bill-head">
          <span>Riverside General Hospital</span>
          <span>Before → after</span>
        </div>
        {LINES.map((l) => (
          <div key={l.what} className="exc-line">
            <div className="exc-line-main">
              <span className="exc-what">{l.what}</span>
              {l.why && <span className="exc-why">{l.why}</span>}
            </div>
            <span className="exc-amts num">
              {l.was !== l.now && <s>${l.was}</s>}
              <span className={l.was !== l.now ? 'is-new' : ''}>${l.now}</span>
            </span>
          </div>
        ))}
        <div className="exc-line">
          <div className="exc-line-main">
            <span className="exc-what">Financial assistance discount</span>
            <span className="exc-why">The hospital&apos;s own policy, never applied</span>
          </div>
          <span className="exc-amts num"><span className="is-new">−$1,544.00</span></span>
        </div>
        <div className="exc-total">
          <span>You owe</span>
          <span className="num">
            <s>$4,820</s> <strong>$1,950</strong>
          </span>
        </div>
      </div>

      <p className="exc-fine">
        About three weeks start to finish, with no calls on the customer&apos;s side. Every bill is different. If we
        don&apos;t save you at least $129, you get the $129 back.
      </p>
    </Modal>
  );
}
